import { createFileRoute, redirect } from '@tanstack/react-router'
import { PageHeader } from '@/shared/ui/page-header'
import { AllTaskList } from '@/widgets/task-list'

// Задачи по всем сделкам — экран сотрудника. Среза по актору нет: задачи
// обезличены, сотруднику отдаются все.
export const Route = createFileRoute('/_app/tasks')({
  beforeLoad: ({ context }) => {
    if (context.session?.kind === 'customer') throw redirect({ to: '/projects' })
  },
  head: () => ({ meta: [{ title: 'Задачи · STIT Deal' }] }),
  component: TasksPage,
})

function TasksPage() {
  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-6 p-4 md:p-6">
      <PageHeader title="Задачи" />
      <AllTaskList />
    </div>
  )
}
